import React from 'react';
import { Button, Card, Row, Col, Typography, Space, Divider } from 'antd';
import {
  VideoCameraOutlined,
  TeamOutlined,
  MessageOutlined,
  ShareAltOutlined,
  PlayCircleOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';
import './landing.scss';

const { Title, Paragraph, Text } = Typography;

const Landing: React.FC = () => {
  const features = [
    {
      icon: <VideoCameraOutlined className="feature-icon" />,
      title: 'Live Video Streaming',
      description: 'High-quality video conferencing with crystal clear audio and video'
    },
    {
      icon: <TeamOutlined className="feature-icon" />,
      title: 'Group Sessions',
      description: 'Host interactive group sessions with multiple participants'
    },
    {
      icon: <MessageOutlined className="feature-icon" />,
      title: 'Real-time Chat',
      description: 'Communicate seamlessly with built-in chat functionality'
    },
    {
      icon: <ShareAltOutlined className="feature-icon" />,
      title: 'Screen Sharing',
      description: 'Share your screen for presentations and collaboration'
    }
  ];

  const benefits = [
    'HD video quality',
    'Low latency streaming',
    'Cross-platform compatibility',
    'Secure connections',
    'Easy to use interface',
    '24/7 support'
  ];

  console.log('Version: 20260422');
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="landing-header">
        <div className="header-content">
          <div className="logo-section">
            <img src="/logo.svg" alt="FlexifyMe" className="logo" />
            {/* <span className="brand-name">FlexifyMe</span> */}
          </div>
          <div className="header-actions">
            <Button
              onClick={() => {
                window.location.href = 'https://www.flexifyme.com/';
              }}
              type="primary"
              size="large"
              className="get-started-btn"
            >
              Get Started
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <Title level={1} className="hero-title">
              Welcome to <span className="highlight">FlexifyMe Live</span>
            </Title>
            <Paragraph className="hero-subtitle">
              Experience the future of live streaming and video conferencing. Connect, collaborate, and communicate with
              crystal clear quality.
            </Paragraph>
            <Space size="large" className="hero-buttons">
              <Button
                type="primary"
                size="large"
                icon={<PlayCircleOutlined />}
                className="primary-btn"
                onClick={() => {
                  window.location.href = 'https://www.flexifyme.com/';
                }}
              >
                Start Live Session
              </Button>
              <Button
                size="large"
                className="secondary-btn"
                onClick={() => {
                  window.location.href = 'https://www.flexifyme.com/';
                }}
              >
                Learn More
              </Button>
            </Space>
          </div>
          <div className="hero-visual">
            <div className="video-preview">
              <div className="video-placeholder">
                <VideoCameraOutlined className="video-icon" />
                <Text className="video-text">Live Preview</Text>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      {/* <section className="features-section">
        <div className="container">
          <Title level={2} className="section-title">
            Powerful Features
          </Title>
          <Paragraph className="section-subtitle">
            Everything you need for seamless live streaming and video conferencing
          </Paragraph>

          <Row gutter={[32, 32]} className="features-grid">
            {features.map((feature, index) => (
              <Col xs={24} sm={12} lg={6} key={index}>
                <Card className="feature-card" hoverable>
                  <div className="feature-content">
                    <div className="feature-icon-wrapper">
                      {feature.icon}
                    </div>
                    <Title level={4} className="feature-title">
                      {feature.title}
                    </Title>
                    <Paragraph className="feature-description">
                      {feature.description}
                    </Paragraph>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section> */}

      {/* Benefits Section */}
      {/* <section className="benefits-section">
        <div className="container">
          <Row gutter={[48, 48]} align="middle">
            <Col xs={24} lg={12}>
              <Title level={2} className="section-title">
                Why Choose FlexifyMe Live?
              </Title>
              <Paragraph className="section-subtitle">
                Built with cutting-edge technology to deliver the best user experience
              </Paragraph>
              <div className="benefits-list">
                {benefits.map((benefit, index) => (
                  <div key={index} className="benefit-item">
                    <CheckCircleOutlined className="benefit-icon" />
                    <Text className="benefit-text">{benefit}</Text>
                  </div>
                ))}
              </div>
            </Col>
            <Col xs={24} lg={12}>
              <div className="stats-container">
                <div className="stat-item">
                  <Title level={1} className="stat-number">99.9%</Title>
                  <Text className="stat-label">Uptime</Text>
                </div>
                <div className="stat-item">
                  <Title level={1} className="stat-number">4K</Title>
                  <Text className="stat-label">Video Quality</Text>
                </div>
                <div className="stat-item">
                  <Title level={1} className="stat-number">24/7</Title>
                  <Text className="stat-label">Support</Text>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section> */}

      {/* CTA Section */}
      {/* <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <Title level={2} className="cta-title">
              Ready to Get Started?
            </Title>
            <Paragraph className="cta-subtitle">
              Join thousands of users who trust FlexifyMe Live for their streaming needs
            </Paragraph>
            <Button
              type="primary"
              size="large"
              icon={<PlayCircleOutlined />}
              className="cta-button"
            >
              Start Your First Session
            </Button>
          </div>
        </div>
      </section> */}

      {/* Footer */}
      <footer className="landing-footer">
        <div className="container">
          <div className="footer-content">
            {/* <div className="footer-logo">
              <img src="/logo.svg" alt="FlexifyMe" className="footer-logo-img" />
            </div> */}
            <div className="footer-links">
              <Text className="footer-text">© 2024 FlexifyMe. All rights reserved.</Text>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
